let now = new Date();
function currentDate(date) {
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = days[date.getDay()];
  let hours = date.getHours();
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  let currentDayTime = `${day} ${hours}:${minutes}`;
  return currentDayTime;
}
let cDate = document.querySelector("#current-day");
cDate.innerHTML = currentDate(now);

function displayWeather(response) {
  document.querySelector(".city").innerHTML = response.data.name;
  document.querySelector("#wisibility").innerHTML =
    response.data.weather[0].main;
  document.querySelector("#current-temp").innerHTML = Math.round(
    response.data.main.temp
  );
  celciusTemp = Math.round(response.data.main.temp);
  document.querySelector(
    "#humidity"
  ).innerHTML = `${response.data.main.humidity}%`;
  document.querySelector(
    "#wind"
  ).innerHTML = `${response.data.wind.speed} km/h`;
  document
    .querySelector("#icon")
    .setAttribute(
      "src",
      `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    );
  document
    .querySelector("#icon")
    .setAttribute("alt", response.data.weather[0].main);

  getForecast(response.data.coord);
}

function getForecast(cordinats) {
  let apiKey = "d12988a8d3aef2fdc59d96ed1c914a1f";
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${cordinats.lat}&lon=${cordinats.lon}&appid=${apiKey}&units=metric`;

  axios.get(apiUrl).then(displayForecast);
}
function formateDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[day];
}

function displayForecast(response) {
  let forecast = response.data.daily;
  let forecastElement = document.querySelector("#forecast");
  let forecastHtml = `<div class="row">`;
  forecast.forEach(function (forecastDay, index) {
    if (index < 6) {
      forecastHtml =
        forecastHtml +
        `
            <div class="col-2 forecast-weather${index}" >
              <div class="day"> ${formateDay(forecastDay.dt)} </div>
              <img src="http://openweathermap.org/img/wn/${
                forecastDay.weather[0].icon
              }@2x.png" alt="sun" width="45" />
              <div class="forecast-temp">
                <span class="max-temp">${Math.round(
                  forecastDay.temp.max
                )}º</span>
                <span class="mіп-temp">${Math.round(
                  forecastDay.temp.min
                )}º</span>
              </div>
            </div>
          `;
    }
  });

  forecastHtml = forecastHtml + `</div>`;
  forecastElement.innerHTML = forecastHtml;
}

function handlePosition(position) {
  let lat = position.coords.latitude;
  let lon = position.coords.longitude;
  let apiKey = "d12988a8d3aef2fdc59d96ed1c914a1f";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${apiKey}`;
  axios.get(apiUrl).then(displayWeather);
}
function getCurrentPosition() {
  navigator.geolocation.getCurrentPosition(handlePosition);
}

function getNewPosition(event) {
  event.preventDefault();
  let newCity = document.querySelector("#new-city").value;
  let apiKey = "d12988a8d3aef2fdc59d96ed1c914a1f";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${newCity}&units=metric&appid=${apiKey}`;
  axios.get(apiUrl).then(displayWeather);
}

function search(city) {
  let apiKey = "d12988a8d3aef2fdc59d96ed1c914a1f";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${apiKey}`;
  axios.get(apiUrl).then(displayWeather);
}

search("New York");

let changeButtton = document.querySelector("#city-changing");
changeButtton.addEventListener("submit", getNewPosition);

let currentButton = document.querySelector("#current-city");
currentButton.addEventListener("click", getCurrentPosition);
